import React from 'react';
import styles from './O_CapsuleLayout.module.css';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import A_Indicator from '@/components/A_Atoms/A_Indicator/A_Indicator';
import cn from 'classnames';

interface O_CapsuleLayoutProps {
  title: string;
  commentCount: number;
  plantCount: number;
}

export default function O_CapsuleLayout({
  title,
  commentCount,
  plantCount,
}: O_CapsuleLayoutProps) {
  return (
    <div className={styles.wrapper}>
      <span className={cn(styles.title, 'text-p-7')}>{title}</span>
      <div className={styles.indicators_wrapper}>
        <A_Indicator
          count={commentCount}
          icon={
            <Q_Icon.CommentIndicatorIcon width={24} height={24} fill='none' />
          }
        />
      </div>
    </div>
  );
}
